"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./simple-enquiry-dto");
class LeadCardDto {
}
exports.LeadCardDto = LeadCardDto;
